import axios from "axios";
import baseURL from "../../Config";
export async function coffeeRequest(
  path = "",
  data,
  method = "GET",
  blob = false
) {
  const stored = JSON.parse(
    localStorage.getItem("userDetails") ||
      localStorage.getItem("adminUser") ||
      "{}"
  );
  const token = stored?.data?.token || stored?.data?.accessToken;
  const response = await axios({
    url: `${baseURL}coffee-records${path}`,
    method,
    data,
    headers: { authorization: `Bearer ${token}` },
    ...(blob ? { responseType: "blob" } : {}),
  });
  return blob ? response.data : response.data.data;
}
export const errorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "No se pudo completar la operación. Inténtalo de nuevo.";
export const newRequestId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join(
    ""
  );
};
